import logo from "../../../assets/images/logo-hacom-2024.png";
import logoDVT from "../../../assets/images/logoDVT.svg";
import style from "./Printer.module.css";

const PrinterReturnCustomers = ({
  innerRef,
  dataPrint,
  dataPYCXL,
  isCheck,
}: {
  innerRef: any;
  dataPrint: any;
  dataPYCXL: any;
  isCheck?: any;
}) => {
  const getMaxDateValue = () => {
    if (
      !dataPrint?.tblWarrantyServiceRequestFormDetailModels ||
      dataPrint?.tblWarrantyServiceRequestFormDetailModels?.length === 0
    )
      return null;

    const parseDateTime = (str: any) => {
      if (!str) return 0;
      const [datePart, timePart] = str.split(" ");
      const [day, month, year] = datePart.split("/");
      const [hour, minute, second] = timePart.split(":");

      return new Date(year, month - 1, day, hour, minute, second).getTime();
    };

    const maxItem =
      dataPrint?.tblWarrantyServiceRequestFormDetailModels?.reduce(
        (prev: any, current: any) => {
          const prevTime = parseDateTime(prev.attribute48);
          const currentTime = parseDateTime(current.attribute48);
          return currentTime > prevTime ? current : prev;
        },
      );

    return maxItem.attribute48 ?? "";
  };

  return (
    <div ref={innerRef} className={style.main}>
      <div
        className={
          dataPrint?.companyCode === "DVT"
            ? `${style.header} ${style.bdRed}`
            : `${style.header}`
        }
      >
        <img
          className={
            // dataPrint?.branchId === 222 || dataPrint?.branchId === 223
            dataPrint?.companyCode === "DVT" ? `${style.customImg}` : ""
          }
          src={
            // dataPrint?.branchId === 222 || dataPrint?.branchId === 223
            dataPrint?.companyCode === "DVT" ? logoDVT : logo
          }
          alt={dataPrint?.companyCode === "DVT" ? "logoDVT" : "logo Hacom"}
          width={
            // dataPrint?.branchId === 222 || dataPrint?.branchId === 223
            dataPrint?.companyCode === "DVT" ? 225 : 150
          }
          height={
            // dataPrint?.branchId === 222 || dataPrint?.branchId === 223
            dataPrint?.companyCode === "DVT" ? 50 : "auto"
          }
          style={{
            objectFit: "contain",
          }}
        />
        <div>
          <div className={style.line}>
            <h3>
              {" "}
              {dataPrint?.companyCode === "DVT"
                ? "CÔNG TY CỔ PHẦN HACOM DỊCH VỤ TỐT"
                : "CÔNG TY CỔ PHẦN ĐẦU TƯ CÔNG NGHỆ HACOM"}
            </h3>
          </div>
          <div className={style.line}>
            <p className={style.cText}>Chi nhánh: </p>
            <p>{dataPrint.nameBranch}</p>
          </div>
          {dataPrint?.companyCode === "DVT" ? (
            <div className={style.line}>
              <p className={style.cText}>Địa chỉ:</p>
              <p>{dataPrint.addressBranch}</p>
            </div>
          ) : (
            <div className={style.line}>
              <p className={style.cText}>Bộ phận/Phòng ban:</p>
              <p>Phòng kỹ thuật bảo hành</p>
            </div>
          )}

          <div className={style.line}>
            <div>
              <p className={style.cText}>Tel: </p>
              <p>
                {" "}
                {dataPrint?.companyCode === "DVT" ? "1800 8091" : "1900 1903"}
              </p>
            </div>
            <div>
              <p className={style.cText}>Máy lẻ:</p>
              <p>25393</p>
            </div>
          </div>
          <div className={style.line}>
            <p className={style.cText}>Email:</p>
            <p>
              {dataPrint?.companyCode === "DVT"
                ? "info@dichvutot.vn"
                : "baohanh@hacom.vn"}
            </p>
          </div>
        </div>
      </div>
      <div className={style.body}>
        <div className={style.title}>
          <h2>
            PHIẾU XUẤT TRẢ {dataPrint?.companyCode === "DVT" ? "" : "BẢO HÀNH"}
          </h2>
          <p className={`${style.italic} ${style.mtt20}`}>
            Ngày {String(new Date().getDate()).padStart(2, "0")} tháng{" "}
            {String(new Date().getMonth() + 1).padStart(2, "0")} năm{" "}
            {new Date().getFullYear()}
          </p>
          <p className={`${style.mtt15}`}>Mã: {dataPYCXL?.requestNum}</p>
        </div>
        <div className={style.info}>
          <div className={`${style.flexGap5} ${style.mbt25}`}>
            <p>Khách hàng:</p>
            <p>{dataPYCXL?.custMeeting}</p>
          </div>
          <div className={`${style.flexGap5} ${style.mbt25}`}>
            <p>Địa chỉ:</p>
            <p>
              {[dataPYCXL.additionalAddress, dataPYCXL.meetingAddress]
                .filter((i) => i && String(i).length > 0)
                .join(" - ")}
            </p>
          </div>
          <div className={`${style.flexGap50} ${style.mbt25}`}>
            <div className={`${style.flexGap5}`}>
              <p>Nhân viên xuất trả:</p>
              <p>{!isCheck ? dataPrint?.empnameincharge : dataPrint?.owEmp}</p>
            </div>
            <div className={`${style.flexGap5}`}>
              <p>Ngày xuất trả:</p>
              {!isCheck ? (
                isNaN(+new Date(getMaxDateValue())) ? (
                  <p>{getMaxDateValue()}</p>
                ) : (
                  <p>
                    {String(
                      new Date(getMaxDateValue() ?? "").getHours(),
                    ).padStart(2, "0")}
                    :
                    {String(
                      new Date(getMaxDateValue() ?? "").getMinutes(),
                    ).padStart(2, "0")}{" "}
                    {String(
                      new Date(getMaxDateValue() ?? "").getMonth() + 1,
                    ).padStart(2, "0")}
                    /
                    {String(
                      new Date(getMaxDateValue() ?? "").getDate(),
                    ).padStart(2, "0")}
                    /{new Date(getMaxDateValue() ?? "").getFullYear()}
                  </p>
                )
              ) : (
                dataPrint?.owDate && (
                  <p>
                    {String(
                      new Date(dataPrint?.owDate || "").getHours(),
                    ).padStart(2, "0")}
                    :
                    {String(
                      new Date(dataPrint?.owDate || "").getMinutes(),
                    ).padStart(2, "0")}{" "}
                    {String(
                      new Date(dataPrint?.owDate || "").getDate(),
                    ).padStart(2, "0")}
                    /
                    {String(
                      new Date(dataPrint?.owDate || "").getMonth() + 1,
                    ).padStart(2, "0")}
                    /{new Date(dataPrint?.owDate || "").getFullYear()}
                  </p>
                )
              )}
            </div>
          </div>
          <div className={`${style.mbt25} ${style.flexGap50}`}>
            <div className={`${style.flexGap5}`}>
              <p>Người nhận:</p>
              <p>{dataPYCXL?.custMeeting}</p>
            </div>
            <div className={`${style.flexGap5}`}>
              <p>Số điện thoại:</p>
              <p>{dataPYCXL?.custPhone}</p>
            </div>
          </div>
          <div className={`${style.mbt25} ${style.flexGap50}`}>
            <div className={`${style.flexGap5}`}>
              <p>Diễn giải:</p>
              <p>{isCheck ? dataPrint?.owNote : dataPrint?.note}</p>
            </div>
          </div>
        </div>
        <div className={`${style.product} ${style.mt15}`}>
          <p className={`${style.italic} ${style.fw} ${style.mbt25}`}>
            Dưới đây là bảng kê chi tiết sản phẩm trả cho quý khách hàng:
          </p>
          {!isCheck ? (
            <table className={style.table}>
              <thead>
                <tr>
                  <th rowSpan={2}>STT</th>
                  <th colSpan={3}>
                    Sản phẩm nhận{" "}
                    {dataPrint?.companyCode === "DVT" ? "" : "bảo hành"}
                  </th>
                  <th rowSpan={2}>Ngày mua</th>
                  <th rowSpan={2}>Mã phiếu nhập</th>
                  <th colSpan={3}>
                    Sản phẩm trả{" "}
                    {dataPrint?.companyCode === "DVT" ? "" : "bảo hành"}
                  </th>
                  <th rowSpan={2}>Loại dịch vụ</th>
                  <th rowSpan={2}>Ghi chú</th>
                </tr>
                <tr>
                  <th>Tên sản phẩm</th>
                  <th>Serial</th>
                  <th>ĐVT</th>
                  <th>Tên sản phẩm</th>
                  <th>Serial</th>
                  <th>ĐVT</th>
                </tr>
              </thead>
              <tbody>
                {dataPrint?.tblWarrantyServiceRequestFormDetailModels
                  ?.filter((i: any) => i.attribute10 === "TRA_KHACH")
                  ?.map((item: any, index: any) => (
                    <tr>
                      <td>{index + 1}</td>
                      <td>{item.itemName}</td>
                      <td>{item.serial}</td>
                      <td>{item.uomName}</td>
                      <td>
                        {item.buyingDate !== null
                          ? `${String(
                              new Date(item?.buyingDate).getDate(),
                            ).padStart(2, "0")}/${String(
                              new Date(item?.buyingDate).getMonth() + 1,
                            ).padStart(2, "0")}/${new Date(
                              item?.buyingDate,
                            ).getFullYear()}`
                          : ""}
                      </td>
                      <td>Không có</td>
                      <td>{item.itemName}</td>
                      <td>{item.serial}</td>
                      <td>{item.uomName}</td>
                      <td>{item.serviceType}</td>
                      <td>{item.note}</td>
                    </tr>
                  ))}
                <tr>
                  <td style={{ border: "none" }}>Tổng cộng</td>
                  <td
                    style={{ alignItems: "center", border: "none" }}
                    colSpan={3}
                  >
                    {
                      dataPrint?.tblWarrantyServiceRequestFormDetailModels?.filter(
                        (i: any) => i.attribute10 === "TRA_KHACH",
                      )?.length
                    }
                  </td>
                  <td colSpan={2} style={{ border: "none" }}></td>
                  <td
                    style={{ alignItems: "center", border: "none" }}
                    colSpan={3}
                  >
                    {
                      dataPrint?.tblWarrantyServiceRequestFormDetailModels?.filter(
                        (i: any) => i.attribute10 === "TRA_KHACH",
                      )?.length
                    }
                  </td>
                  <td colSpan={2} style={{ border: "none" }}></td>
                </tr>
              </tbody>
            </table>
          ) : (
            <table className={style.table}>
              <thead>
                <tr>
                  <th rowSpan={2}>STT</th>
                  <th colSpan={3}>
                    Sản phẩm nhận{" "}
                    {dataPrint?.companyCode === "DVT" ? "" : "bảo hành"}
                  </th>
                  <th rowSpan={2}>Ngày mua</th>
                  <th rowSpan={2}>Mã phiếu nhập</th>
                  <th colSpan={3}>
                    Sản phẩm trả{" "}
                    {dataPrint?.companyCode === "DVT" ? "" : "bảo hành"}
                  </th>
                  <th rowSpan={2}>Loại dịch vụ</th>
                  <th rowSpan={2}>Ghi chú</th>
                </tr>
                <tr>
                  <th>Tên sản phẩm</th>
                  <th>Serial</th>
                  <th>ĐVT</th>
                  <th>Tên sản phẩm</th>
                  <th>Serial</th>
                  <th>ĐVT</th>
                </tr>
              </thead>
              <tbody>
                {dataPrint?.tblWarrantyReceiveTicketDetailModels
                  // ?.filter(
                  //   (item: any) =>
                  //     item?.serialStatus === "Trả khách" ||
                  //     item?.serialStatus === "Đổi mã" ||
                  //     item?.attribute10 === "TRA_KHACH" ||
                  //     item?.attribute10 === "DOI_MA"
                  // )
                  ?.map((item: any, index: any) => (
                    <tr>
                      <td>{index + 1}</td>
                      <td>{item?.itemName}</td>
                      <td>{item?.serial}</td>
                      <td>{item?.uomName}</td>
                      <td>
                        {item.buyingDate !== null
                          ? `${String(
                              new Date(item?.buyingDate).getDate(),
                            ).padStart(2, "0")}/${String(
                              new Date(item?.buyingDate).getMonth() + 1,
                            ).padStart(2, "0")}/${new Date(
                              item?.buyingDate,
                            ).getFullYear()}`
                          : ""}
                      </td>
                      <td></td>
                      <td>
                        {item?.newItemName !== null
                          ? item?.newItemName
                          : item?.itemName}
                      </td>
                      <td>
                        {item.newSerial !== null
                          ? item?.newSerial
                          : item?.serial}
                      </td>
                      <td>{item?.uomName}</td>
                      <td>{item?.serviceType}</td>
                      <td>{item?.note}</td>
                    </tr>
                  ))}
                <tr>
                  <td style={{ border: "none" }}>Tổng cộng</td>
                  <td
                    style={{ alignItems: "center", border: "none" }}
                    colSpan={3}
                  >
                    {
                      // ?.filter(
                      //   (item: any) =>
                      //     item?.serialStatus === "Trả khách" ||
                      //     item?.serialStatus === "Đổi mã" ||
                      //     item?.attribute10 === "TRA_KHACH" ||
                      //     item?.attribute10 === "DOI_MA"
                      // )
                      dataPrint?.tblWarrantyReceiveTicketDetailModels?.length
                    }
                  </td>
                  <td colSpan={2} style={{ border: "none" }}></td>
                  <td
                    style={{ alignItems: "center", border: "none" }}
                    colSpan={3}
                  >
                    {
                      // ?.filter(
                      //   (item: any) =>
                      //     item?.serialStatus === "Trả khách" ||
                      //     item?.serialStatus === "Đổi mã" ||
                      //     item?.attribute10 === "TRA_KHACH" ||
                      //     item?.attribute10 === "DOI_MA"
                      // )
                      dataPrint?.tblWarrantyReceiveTicketDetailModels?.length
                    }
                  </td>
                  <td colSpan={2} style={{ border: "none" }}></td>
                </tr>
              </tbody>
            </table>
          )}
        </div>
        <div className={`${style.mbt25} ${style.flexGap50}`}>
          <div className={`${style.flexGap5}`}>
            <p className={`${style.fw} ${style.width5}`}>Lưu ý:</p>
            <p>
              Quý khách kiểm tra kỹ thông số, cấu hình, tình trạng, số lượng
              hàng hóa đầy đủ khi nhận lại hàng (linh kiện, phụ kiện đi kèm, đĩa
              cài, sách, vỏ hộp,... nếu có).
            </p>
          </div>
        </div>
      </div>
      <div className={style.signature}>
        {dataPrint?.companyCode !== "DVT" ? (
          <div>
            <p className={style.fw}>Trưởng bộ phận</p>
            <p>
              {"("}Ký & ghi rõ họ tên{")"}
            </p>
          </div>
        ) : (
          <></>
        )}
        <div>
          <p className={style.fw}>Người lập phiếu</p>
          <p>
            {"("}Ký & ghi rõ họ tên{")"}
          </p>
        </div>
        {dataPrint?.companyCode !== "DVT" ? (
          <div>
            <p className={style.fw}>Thủ kho</p>
            <p>
              {"("}Ký & ghi rõ họ tên{")"}
            </p>
          </div>
        ) : (
          <></>
        )}
        <div>
          <p className={style.fw}>Người nhận hàng</p>
          <p>
            {"("}Ký & ghi rõ họ tên{")"}
          </p>
        </div>
      </div>
      <div className={`${style.flexGap20} ${style.fixedBottomAndRight}`}>
        <div className={`${style.flexGap5}`}>
          <p>Nhân viên in phiếu:</p>
          <p>
            {`${
              JSON.parse(localStorage.getItem("userLoginHeader") || "{}")?.code
            } - ${
              JSON.parse(localStorage.getItem("userLoginHeader") || "{}")
                ?.fullname
            }`}
          </p>
        </div>
        <div className={`${style.flexGap5}`}>
          <p>Ngày in phiếu:</p>
          <p>
            {String(new Date().getHours()).padStart(2, "0")}:
            {String(new Date().getMinutes()).padStart(2, "0")}{" "}
            {String(new Date().getDate()).padStart(2, "0")}/
            {String(new Date().getMonth() + 1).padStart(2, "0")}/
            {new Date().getFullYear()}
          </p>
        </div>
      </div>
    </div>
  );
};

export default PrinterReturnCustomers;
